var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgUserTag = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/user-tag"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user-tag"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.667 25.1468H23.6536C22.587 25.1468 21.5737 25.5601 20.827 26.3068L18.547 28.5601C17.507 29.5868 15.8137 29.5868 14.7737 28.5601L12.4937 26.3068C11.747 25.5601 10.7203 25.1468 9.66699 25.1468H8.66699C6.45366 25.1468 4.66699 23.3735 4.66699 21.1868V6.64014C4.66699 4.45347 6.45366 2.68018 8.66699 2.68018H24.667C26.8803 2.68018 28.667 4.45347 28.667 6.64014V21.1868C28.667 23.3602 26.8803 25.1468 24.667 25.1468Z",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.6672 13.3334C18.383 13.3334 19.7739 11.9425 19.7739 10.2267C19.7739 8.51096 18.383 7.12012 16.6672 7.12012C14.9515 7.12012 13.5605 8.51096 13.5605 10.2267C13.5605 11.9425 14.9515 13.3334 16.6672 13.3334Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M22.0007 20.8798C22.0007 18.4798 19.614 16.5332 16.6673 16.5332C13.7207 16.5332 11.334 18.4798 11.334 20.8798",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUserTag, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/user-tag.524b318d.svg";
export { ForwardRef as ReactComponent };